import { OptionModel } from "../../common/types/OptionModel";

export const userType: OptionModel[] = [
    { 
        value: 2, 
        label: "Firma Yetkilisi" 
    },
    { 
        value: 3, 
        label: "Müşteri Temsilcisi" 
    },
    { 
        value: 4, 
        label: "Bayi / Müşteri" 
    },
    { 
        value: 5, 
        label: "Altbayi" 
    },
];

export const permissions = [
    // {
    //     value: 1,
    //     label: "Müşteri Tanımla",
    //     formname: "defineCustomer",
    //     tier: 1
    // }, 
    {
        value: 2,
        label: "Ödeme Al",
        formname: "paymentCollection",
        tier: 1
    },              
    {
        value: 3,
        label: "Serbest Ödeme Al",
        formname: "freePaymentCollection",
        tier:1
    },     
    {
        value: 4,
        label: "Ödeme Linki Gönder",
        formname: "sendPaymentLink",
        tier: 1
    },   
    {
        value: 5,
        label: "Ödeme İptali",
        formname: "paymentCancellation",
        tier: 2
    },      
    {
        value: 6,
        label: "Ödeme İadesi",
        formname: "paymentRefund",
        tier: 2
    }, 
    {
        value: 7,
        label: "İşlem Listesi",
        formname: "transactionList",
        tier:1
    },       
    {
        value: 8,
        label: "Banka Seçimi",
        formname: "bankSelection",
        tier: 1
    },       
    {
        value: 9,
        label: "Erp Entegrasyonu",
        formname: "erpIntegration",
        tier: 3
    },     
    {
        value: 10,
        label: "Erp Bakiye Sorgula",
        formname: "erpBalanceInquiry",
        tier: 1
    },    
    {
        value: 11,
        label: "Kullanıcı İşlemleri",
        formname: "userOperations",
        tier: 3
    },
    {
        value: 12,
        label: "Müşteri Listesi",
        formname: "customerList",
        tier: 0
    },
    {
        value: 13,
        label: "Komisyon Seçimi",
        formname: "commissionSelection",
        tier: 2
    }
];